export const kotiTitleGenerator = (text) => {
    return `${text} - Delight`
}

export const kotiImageAltGenerator = (text) => {
    return kotiTitleGenerator(text)
}
